(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/best-rows/assets/javascripts/models/best-rows.js') >= 0) return;  svs.modules.push('/components/sport/best-rows/assets/javascripts/models/best-rows.js'); 'use strict';

svs.sport.best_rows.models.BestRows = Backbone.Model.extend({
  log: new svs.core.log.Logger('svs.sport.best_rows.models.best_rows'),
  expandedRows: [],
  topCorrect: [],
  lastOutcomes: ['X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X', 'X'],
  hasTopCorrects: false,
  matchList: null,

  initialize: function initialize(options) {
    var _this = this;

    if (this.validValues(options)) {
      svs.sport.best_rows.models.wager = options.wager;
      var modelData = options.matchList.models.map(function (model) {
        return model.attributes;
      });
      this.set('matchList', new svs.sport.best_rows.collections.BestRowsMatchList(modelData));

      if (this.validateWager()) {
        var wager = svs.sport.best_rows.models.wager,
            board = this.getBoard(),
            system = wager.description,
            systemType = wager.systemType,
            uRows = this.getURows();
        this.setExpandedRows(systemType, system, board, uRows, options.matchList.expandedRows);
        this.setDistribution();
        this.setupRowsArray();
        this.sortRowsArray();
      }

      options.matchList.on('change', function (update) {
        _this.onMatchListUpdate(update);
      });
    }
  },

  validValues: function validValues(values) {
    for (var prop in values) {
      if (Object.prototype.hasOwnProperty.call(values, prop)) {
        if (typeof values[prop] === 'undefined') {
          this.log.error("".concat(prop, " is undefined"));
          return false;
        }

        if (values[prop] === null) {
          this.log.error("".concat(prop, " is null"));
          return false;
        }
      }
    }

    return true;
  },

  sortRowsArray: function sortRowsArray() {
    this.get('rows').sort(function (a, b) {
      return b.corrects - a.corrects;
    });
    this.get('rowsCollection').reset(this.get('rows').slice(0, 60));
  },
  onMatchListUpdate: function onMatchListUpdate(update) {
    this.get('matchList').update(update);
    this.updateOutcomes();
    this.sortRowsArray();
  },

  getNewOutcomes: function getNewOutcomes() {
    var outcomes = [];
    this.get('matchList').each(function (model) {
      return outcomes.push(model.get('outcome'));
    });
    return outcomes;
  },
  numberOfCorrects: function numberOfCorrects(row, newOutcomes) {
    var corrects = 0;
    newOutcomes.forEach(function (m, index) {
      if (row[index] === m) corrects++;
    });
    return corrects;
  },

  updateOutcomes: function updateOutcomes() {
    var _this2 = this;

    var newOutcomes = this.getNewOutcomes(),
        isToppTipset = svs.utils.products.helpers.isTopptipset(this.get('draw').productFamily),
        isPowerplay = svs.utils.products.helpers.isPowerplay(this.get('draw').productName);

    if (isToppTipset || isPowerplay) {
      this.topCorrect = [0];
    } else {
      this.topCorrect = [0, 0, 0, 0];
    }

    this.get('rows').forEach(function (r) {
      r.disabledMarks = _this2.getDisabled(r.marks);
      r.corrects = _this2.numberOfCorrects(r.marks, newOutcomes);
      r.hits = _this2.getHits(r.marks, newOutcomes);

      if (isToppTipset || isPowerplay) {
        r.isInPriceGroup = r.corrects === 8;
      } else {
        r.isInPriceGroup = r.corrects >= 10;
      }

      r.drawClosed = _this2.get('matchList').at(0).get('drawClosed');

      if (isToppTipset || isPowerplay) {
        if (r.corrects === 8) {
          _this2.topCorrect[0] += 1;
          _this2.hasTopCorrects = true;
        }
      } else {
        if (r.corrects >= 10) {
          if (r.corrects === 13) {
            _this2.topCorrect[0] += 1;
          } else if (r.corrects === 12) {
            _this2.topCorrect[1] += 1;
          } else if (r.corrects === 11) {
            _this2.topCorrect[2] += 1;
          } else if (r.corrects === 10) {
            _this2.topCorrect[3] += 1;
          }

          _this2.hasTopCorrects = true;
        }
      }
    });
    this.trigger('topDone', this.topCorrect);
  },

  setupRowsArray: function setupRowsArray() {
    var length = this.expandedRows.length,
        newOutcomes = this.getNewOutcomes(),
        rows = [];
    this.topCorrect = [0, 0, 0, 0];

    for (var i = 0; i < length; ++i) {
      var marks = this.expandedRows[i],
          disabledMarks = this.getDisabled(marks),
          corrects = this.numberOfCorrects(marks, newOutcomes),
          hits = this.getHits(marks, newOutcomes),
          isInPriceGroup = corrects >= 10,
          productname = svs.sport.best_rows.models.wager.productName.toLowerCase();
      var drawClosed = this.get('matchList').at(0).get('drawClosed');

      if (corrects >= 10) {
        this.hasTopCorrects = true;
        if (corrects === 13) this.topCorrect[0]++;
        if (corrects === 12) this.topCorrect[1]++;
        if (corrects === 11) this.topCorrect[2]++;
        if (corrects === 10) this.topCorrect[3]++;
      }

      rows.push({
        marks: marks,
        corrects: corrects,
        hits: hits,
        disabledMarks: disabledMarks,
        isInPriceGroup: isInPriceGroup,
        productname: productname,
        drawClosed: drawClosed
      });
    }

    this.set('rows', rows);
    this.set('rowsCollection', new Backbone.Collection(rows));
    this.trigger('topDone', this.topCorrect);
  },

  getHits: function getHits(row, outcomes) {
    var hits = [];
    row.forEach(function (mark, index) {
      hits.push(mark === outcomes[index]);
    });
    return hits;
  },

  getDisabled: function getDisabled(row) {
    var _this3 = this;

    var disabled = [];
    row.forEach(function (mark, index) {
      var match = _this3.get('matchList').at(index);

      if (match) {
        if (match.get('hasMatchStarted') || match.get('cancelled') && match.get('forecastVerified')) {
          disabled.push(false);
        } else {
          disabled.push(true);
        }
      }
    });
    return disabled;
  },

  validateWager: function validateWager() {
    if (!Array.isArray(svs.sport.best_rows.models.wager.wager.bets) || svs.sport.best_rows.models.wager.wager.bets.length === 0) {
      this.log.error('svs.sport.best_rows.models.wager.attributes.wager.bets: Missing bets info');
      return false;
    }

    return true;
  },

  getURows: function getURows() {
    var uRows = null;

    if (svs.sport.best_rows.models.wager.systemType === 'USYS') {
      svs.sport.best_rows.models.wager.wager.bets.forEach(function (bet) {
        if (bet.productId !== 'SPORTJOKER') {
          if (bet.game1X2Boards.length > 1) {
            uRows = bet.game1X2Boards[1].boardData;
          }
        }
      });
    }

    return uRows;
  },

  getBoard: function getBoard() {
    var board = null;
    svs.sport.best_rows.models.wager.wager.bets.forEach(function (bet) {
      if (bet.betProperties.indexOf('EGNARADER') > -1 || bet.betProperties.indexOf('REDUCERA_FRITT') > -1) {
        board = bet.er1X2BoardData;
      } else if (bet.productId !== 'SPORTJOKER') {
        board = bet.game1X2Boards[0].boardData;
      }
    });
    return board;
  },

  setExpandedRows: function setExpandedRows(systemType, system, board, uRows, expanded) {
    var _this4 = this;

    if (systemType === 'SROW' && !expanded) {
      svs.sport.best_rows.models.wager.wager.bets.forEach(function (bet) {
        if (bet.betProperties[0] === 'EGNARADER' || bet.betProperties.indexOf('REDUCERA_FRITT') > -1) {
          _this4.expandedRows = svs.sport.expandedSystems.expandMSYS(bet.er1X2BoardData.boards);
        } else if (bet.productId !== 'SPORTJOKER') {
          _this4.expandedRows = [];
          bet.game1X2Boards.forEach(function (board) {
            _this4.expandedRows.push(board.boardData);
          });
        }
      });
    } else {
      if (!expanded) {
        this.expandedRows = svs.sport.expandedSystems.getExpandedRows(system, board, uRows);
      } else {
        this.expandedRows = expanded;
      }
    }
  },

  setDistribution: function setDistribution() {
    var _this5 = this;

    this.set('distribution', svs.sport.expandedSystems.getDistribution(this.expandedRows));
    this.get('matchList').each(function (match, index) {
      match.set('distribution', _this5.get('distribution')[index]);
    });
  }
});
 })(window);